import { Link } from "react-router-dom";

export default function CallToAction() {
  return (
    <section className="call-to-action text-sky-950 mt-25 py-20 px-6 md:px-20">
      <div className="flex flex-col items-center space-y-8 text-center max-w-3xl mx-auto">
        <p className="text-lg md:text-xl leading-relaxed text-gray-600">
          Join us in creating a brighter tomorrow
        </p>
        <div className="flex flex-wrap justify-center gap-10">
          <Link
            to="/our-projects"
            className="cta-button bg-gray-500 text-gray-100 font-semibold text-2xl py-6 px-16 rounded-full transition-all duration-300 shadow-lg transform hover:scale-105 focus:ring focus:ring-gray-500"
          >
            Our Projects
          </Link>
          <Link
            to="/get-involved"
            className="cta-button bg-gray-500 text-gray-100 font-semibold text-2xl py-6 px-16 rounded-full transition-all duration-300 shadow-lg transform hover:scale-105 focus:ring focus:ring-gray-500"
          >
            Get Involved
          </Link>
        </div>
      </div>
    </section>
  );
}
